import React from "react"
import Footer from "./footer"
import Navbarmenu from "./Navbarmenu"
import './style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from "react-helmet";

export default function Layout({ children }) {
    return (
        <>
            <Navbarmenu />
            <Helmet>
                <meta name="description" content="Zabívám se tvorbou videii a focením všech možných událostí. Na mých stránkách si můžete prohlednou ukázku mé tvorby, přečíst reference či mě rovnou kontaktovat."></meta>
                <meta charSet="utf-8" />
                <meta content="width=device-width, initial-scale=1.0" name="viewport" />
                <script src='https://smtpjs.com/v3/smtp.js' type="text/javascript" />
            </Helmet>
            {children}
            <Footer />
        </>
    )
}